import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-page.tsx
/**
* icon.24.page
*
* Keywords: document, file, paper, folded-corner, single, blank, empty, corner-fold
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyLjU5OCA1LjAxYS41LjUgMCAwIDEgLjI1NS4xMzZsNCA0QS41LjUgMCAwIDEgMTYuNSAxMGgtNGEuNS41IDAgMCAxLS41LS41VjZIOC41YS41LjUgMCAwIDAtLjUuNXYxMWEuNS41IDAgMCAwIC41LjVoN2EuNS41IDAgMCAwIC41LS41di02YS41LjUgMCAwIDEgMSAwdjZhMS41IDEuNSAwIDAgMS0xLjUgMS41aC03QTEuNSAxLjUgMCAwIDEgNyAxNy41di0xMUExLjUgMS41IDAgMCAxIDguNSA1aDR6TTEzIDloMi4yOTNMMTMgNi43MDd6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1608
*/
const Icon24Page = memo(function Icon24Page(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12.598 5.01a.5.5 0 0 1 .255.136l4 4A.5.5 0 0 1 16.5 10h-4a.5.5 0 0 1-.5-.5V6H8.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 1 1 0v6a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 7 17.5v-11A1.5 1.5 0 0 1 8.5 5h4zM13 9h2.293L13 6.707z"
		})
	});
});
//#endregion
export { Icon24Page };

//# sourceMappingURL=icon-24-page.js.map